<div class="container padding-top-lg report-container">

    <app-back-nav class="mb-20 hidden-print" [linkText]="'POSITION_PROFILE_REPORT.BACK_TO_ASSESSMENTS' | translate"></app-back-nav>

    <app-report-frame
        class="sub-bk-light"
        [reportTypeName]="'POSITION_PROFILE_REPORT.FIT_REPORT' | translate"
        [noContentCss]="true"
        [headerRatio21]="true"
        [reportOptions]="reportOptions"
        [legend]="legend"
        [showLegend]="true"
        [showLegendIcon]="false"
        [useTableContent]="false"
        *ngIf="reportData">
        <ng-container slot="notable">
            <div class="content">
    
                <div class="row">

                    <div class="main-table">
                        <div class="t-body">

                            <mat-card class="mb-4 p-16 search-box hidden-print">
                                <mat-card-content class="text-subtitle pb-0">
                                    <div class="flex-h full-width gap-10 settings">
                                        <div class="flex1">
                                            <app-employee-and-position-search #empSearch (add)="addEmployee($event)"></app-employee-and-position-search>
                                        </div>
                                        <div class="flex1">
                                            <app-search #search
                                                [inlineButtons]="true"
                                                [isAllowSearch]="true"
                                                [showClearButton]="true"
                                                [placeholder]="'POSITION_PROFILE_REPORT.POSITION_SELECTION' | translate"
                                                [config]="positionSearchConfig"
                                                [showAddButton]="false"
                                                [isCustomAdd]="false"
                                                [isGroup]="true"
                                                [disabledAddButton]="true"
                                                (change)="onPositionOptionClick($event)"
                                                (cleared)="onPositionCleared()"
                                                >
                                            </app-search>

                                            <div class="settings flex-h gap-2">
                                                <div class="settings-panel">
                                                    <div class="panel-title">{{ 'POSITION_PROFILE_REPORT.DISPLAY_EMPLOYEE_DATA' | translate }}</div>
                                                    <div class="panel-content simple-border flex-v">
                                                        <mat-checkbox class="multiline" [(ngModel)]="showEmployeeName">{{ 'POSITION_PROFILE_REPORT.EMPLOYEE_NAME' | translate }}</mat-checkbox>
                                                        <mat-checkbox class="multiline" [(ngModel)]="showEmail">{{ 'POSITION_PROFILE_REPORT.EMAIL_ADDRESS' | translate }}</mat-checkbox>
                                                        <mat-checkbox class="multiline" [(ngModel)]="showEmployeePosition">{{ 'POSITION_PROFILE_REPORT.POSITION' | translate }}</mat-checkbox>
                                                        <mat-checkbox class="multiline" [(ngModel)]="showReviewDate">{{ 'POSITION_PROFILE_REPORT.COMPLETION_DATE' | translate }}</mat-checkbox>
                                                    </div>
                                                </div>
                                                <div class="settings-panel">
                                                    <div class="panel-title">{{ 'POSITION_PROFILE_REPORT.DISPLAY_FACTORS' | translate }}</div>
                                                    <div class="panel-content simple-border flex-v">
                                                        <mat-checkbox class="multiline" [(ngModel)]="showFitScore" (change)="updateColumns()">{{ 'POSITION_PROFILE_REPORT.FIT' | translate }}</mat-checkbox>
                                                        <mat-checkbox class="multiline" [(ngModel)]="showTorzKatt" (change)="updateColumns()">{{ 'POSITION_PROFILE_REPORT.DISTORTION_CLICKING' | translate }}</mat-checkbox>
                                                        <mat-checkbox class="multiline" [(ngModel)]="showThinking" (change)="updateColumns()">{{ 'POSITION_PROFILE_REPORT.CONCEPTUAL_THINKING' | translate }}</mat-checkbox>
                                                        <mat-checkbox class="multiline" [(ngModel)]="showNoProfileCategories" (change)="updateColumns()">{{ 'POSITION_PROFILE_REPORT.FACTORS_WITHOUT_PROFILE' | translate }}</mat-checkbox>
                                                    </div>
                                                </div>
                                                <div class="settings-panel">
                                                    <div class="panel-title">{{ 'POSITION_PROFILE_REPORT.SORTING' | translate }}</div>
                                                    <div class="panel-content simple-border">
                                                        <mat-radio-group [(ngModel)]="listOrder" (change)="changeOrder()" class="flex-v">
                                                            <mat-radio-button value="byAdd">{{ 'POSITION_PROFILE_REPORT.ADDITION_ORDER' | translate }}</mat-radio-button>
                                                            <mat-radio-button value="byName">{{ 'POSITION_PROFILE_REPORT.ABC_ORDER' | translate }}</mat-radio-button>
                                                            <mat-radio-button value="byFitScore">{{ 'POSITION_PROFILE_REPORT.BY_FIT' | translate }}</mat-radio-button>
                                                        </mat-radio-group>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="settings">
                                                <div class="settings-panel">
                                                    <div class="panel-content simple-border flex-v no-height">
                                                        <div class="flex-space-between">
                                                            <mat-checkbox class="multiline" [(ngModel)]="showDistributionTable">{{ 'POSITION_PROFILE_REPORT.SHOW_DISTRIBUTION_TABLE' | translate }}</mat-checkbox>
                                                            <a mat-flat-button class="bt-report-help button-bg-alt1 hidden-print" title="{{ 'REPORT_FRAME.HELP_BUTTON' | translate }}" href="{{ 'REPORT_FRAME.HELP_LINK' | translate }}" target="_blank">
                                                                {{ 'REPORT_FRAME.HELP_BUTTON' | translate }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                            
                                </mat-card-content>
                            </mat-card>
    
                            <app-legend-card [items]="ratingBands"></app-legend-card>

                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="main-table">
                        <div class="t-body">
       
                            <mat-card class="card-table-scroll">
                                     <mat-card-content>
                                        
                                        <table class="table-default profiles-table">
                                            <thead>
                                                <!-- Main Categories-->
                                                <tr class="main-cat-row">
                                                    <th class="right-border"></th>
                                                    <th *ngFor="let qCat of filteredMainCategories" [attr.colspan]="qCat.childCount" class="right-border">{{ qCat.name }}</th>
                                                    <th *ngIf="showFitScore"></th>
                                                </tr>

                                                <!-- Sub Categories-->
                                                <tr class="sub-cat-row">
                                                    <th class="right-border">{{ 'POSITION_PROFILE_REPORT.EMPLOYEE' | translate }}</th>
                                                    <th *ngFor="let col of filteredColumns" class="cat-title" [ngClass]="{'right-border': col.rightBorder, 'uppercase': !col.mainCatName, 'key-factor': col.isKeyFactor }" [matTooltip]="'POSITION.KEY_FACTOR' | translate" [matTooltipDisabled]="!col.isKeyFactor">
                                                        <div class="transform-90">{{ col.name }}</div>
                                                    </th>
                                                    <th class="cat-title" *ngIf="showFitScore">
                                                        <div class="transform-90">{{ 'POSITION_PROFILE_REPORT.FIT' | translate }}</div>
                                                    </th>
                                                </tr>

                                                <!-- Position Profile Min-Max values -->
                                                <tr *ngIf="positionId != null && employeeProfiles?.length > 0" class="row-minmax">
                                                    <th class="right-border">{{ reportOptions.title }}</th>
                                                    <th *ngFor="let col of filteredColumns" [ngClass]="{'right-border': col.rightBorder, 'key-factor': col.isKeyFactor}">
                                                        <span *ngIf="col && col?.min && col?.max">{{ col.min }}-{{ col.max }}</span>
                                                    </th>
                                                    <th *ngIf="showFitScore"></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr *ngFor="let ep of orderedEmployeeProfiles; let i = index">
                                                    <td class="right-border">
                                                        <div class="employee-name">
                                                            <div>
                                                                <div *ngIf="showEmployeeName"><strong>{{ ep.employeeName }}</strong></div>
                                                                <div class="sub-text" *ngIf="showEmail">{{ ep.employeeEmail ?? ep.userName }} {{ ep.employeeIdentifier }}</div>
                                                                <div class="sub-text" *ngIf="showEmployeePosition && ep.employeePositionName">{{ ep.employeePositionName }}</div>
                                                                <div class="sub-text" *ngIf="showReviewDate">{{ 'POSITION_PROFILE_REPORT.COMPLETION_PREFIX' | translate }} {{ ep.reviewDate | localizedDate }}</div>
                                                                <!-- <div class="sub-text" *ngIf="ep.leaders?.length > 0">vezetők: {{ getLeaders(ep.leaders) }}</div> -->
                                                            </div>
                                                            <button mat-icon-button color="primary" class="action-delete hidden-print icon-button small-icon-button" (click)="deleteEmployee(ep.reviewPeriodEmployeeId)" [title]="'POSITION_PROFILE_REPORT.REMOVE_EMPLOYEE' | translate">
                                                                <mat-icon>delete</mat-icon>
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td *ngFor="let col of getSubCatCols(ep.catCols)" class="value-cell" [ngClass]="{'right-border': col.rightBorder, 'key-factor': col.isKeyFactor }" [ngStyle]="{'background-color': col.color }">
                                                        {{ col.value | number:'1.0-0' | nozero }}
                                                    </td>
                                                    <td class="value-cell" *ngIf="showFitScore">
                                                        <span>{{ ep.fitScore }}%</span>
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tfoot *ngIf="columns?.length > 0">
                                                <tr *ngIf="employeeProfiles?.length > 0">
                                                    <td class="right-border"><strong>{{ 'POSITION_PROFILE_REPORT.AVERAGE' | translate }}</strong></td>
                                                    <!-- <td></td> -->
                                                    <td *ngFor="let col of filteredColumns; let i = index" [ngClass]="{'right-border': col.rightBorder, 'key-factor': col.isKeyFactor }">
                                                        <span *ngIf="col">{{ getAverageForCategory(i) | number:'1.1-1' | nozero }}</span>
                                                    </td>
                                                    <td *ngIf="showFitScore"></td>
                                                </tr>
                                            </tfoot>
                                        </table>

                                        
                                     </mat-card-content>
                            </mat-card>
    
                            
                        </div>
                    </div>
                </div>

                <div class="page-break-after" *ngIf="showDistributionTable"></div>
                
                <div class="row" *ngIf="showDistributionTable">
                    <div class="main-table">
                        <div class="t-body">
       
                            <mat-card class="card-table-scroll dist-card">
                                     <mat-card-content>
                                        
                                        <table class="table-default distribution-table">
                                            <thead>
                                                <tr class="main-cat-row">
                                                    <th class="right-border bottom-border"></th>
                                                    <th class="categories right-border bottom-border"></th>
                                                    <th *ngFor="let col of distColumns" class="value-col cat-title bottom-border">
                                                        <div class="transform-90">{{ col }}{{ getNumberHunSuffix(col) }} {{ 'POSITION_PROFILE_REPORT.VALUE_OCCURRENCE_SUFFIX' | translate }}</div>
                                                    </th>
                                                    <th class="value-col cat-title bottom-border">
                                                        <div class="transform-90">{{ 'POSITION_PROFILE_REPORT.FACTOR_AVERAGE' | translate }}</div>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <ng-container *ngFor="let qCat of filteredMainCategories">
                                                    <tr *ngFor="let childCat of displayChildCats(qCat.childCategories); let first = first; let last = last">
                                                      <td *ngIf="first" [attr.rowspan]="qCat.childCount" class="dist-main-cat cat-title right-border bottom-border" [ngClass]="getCategoryCss(qCat)">
                                                        <div class="transform-90">{{ qCat.name }}</div>
                                                      </td>
                                                      <td class="right-border dist-child-cat" [ngClass]="{'uppercase': qCat.code === 'TORZCSAL', 'bottom-border': !!last, 'key-factor': isKeyFactor(childCat.id) }" [matTooltip]="'POSITION.KEY_FACTOR' | translate" [matTooltipDisabled]="!isKeyFactor(childCat.id)">{{ childCat.name }}</td>
                                                      <td *ngFor="let col of distColumns" [ngStyle]="{'background-color': getColor(getCatCount(childCat, col)) }" [ngClass]="{ 'bottom-border': !!last, 'key-factor': isKeyFactor(childCat.id) }">{{ getCatCount(childCat, col) }}</td>
                                                      <td [ngClass]="{ 'bottom-border': !!last, 'key-factor': isKeyFactor(childCat.id) }">{{ getCatAverage(childCat) | number:'1.1-1' }}</td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>

                                         <!-- <div class="legend-section mt-20" *ngIf="positionId != null">
                                            <div class="legend-main-title">{{ 'POSITION_PROFILE_REPORT.LEGEND' | translate }}</div>
                                            <div class="legend-container pt-10">
                                                <div class="legend-color-box key-factor"></div>
                                                <div class="legend-text">{{ 'POSITION.KEY_FACTOR' | translate }}</div>
                                            </div>
                                        </div> -->
                                        
                                     </mat-card-content>
                            </mat-card>
    
                            
                        </div>
                    </div>
                </div>
                          
    
            </div>

        </ng-container>
    
    </app-report-frame>

</div>
